import './topContent.scss';

function TopContent() {
  return (
    <div className="topContent">
      <div className="logo"></div>
      <div className="headerTitle"></div>
      <hr className="dividerRounded"></hr>
    </div>
  );
}

export default TopContent;
